import React from "react";
import MuiFormControlLabel from "@mui/material/FormControlLabel";
import PropTypes from "prop-types";

/**
 * FormControlLabel component wrapper for labeling form controls.
 * Wraps Material-UI FormControlLabel with theme integration.
 * 
 * @component
 * @example
 * <FormControlLabel
 *   control={<Checkbox checked={checked} onChange={handleChange} />}
 *   label="Accept terms"
 * />
 */
const FormControlLabel = (props) => {
  return <MuiFormControlLabel {...props} />;
};

FormControlLabel.propTypes = {
  /**
   * A control element. For instance, it can be a Radio, a Switch or a Checkbox
   */
  control: PropTypes.element.isRequired,
  /**
   * The text to be used in an enclosing label element
   */
  label: PropTypes.node,
  /**
   * If true, the component will be disabled
   */
  disabled: PropTypes.bool,
  /**
   * If true, the label will be displayed as required
   */
  required: PropTypes.bool,
  /**
   * The position of the label
   */
  labelPlacement: PropTypes.oneOf(["end", "start", "top", "bottom"]),
  /**
   * The value of the component
   */
  value: PropTypes.any,
  /**
   * Callback fired when the state is changed
   */
  onChange: PropTypes.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

// No defaultProps - maintain exact MUI FormControlLabel behavior
// MUI FormControlLabel defaults: labelPlacement="end"

export default FormControlLabel;

